import React from 'react'

const TranscriptEditorSpace: React.FC = ({ children }) => (
  <span className="transcript-editor-entity__space">{children}</span>
)

export default TranscriptEditorSpace
